module.exports = __webpack_public_path__ + "img/index-section6-friend1.c9de0636.svg";